export const objToFormData = (value: Object) => {
    const entries = Object.entries(value);
    const form = new FormData();

    entries.forEach((item) => {
        form.append(item[0], item[1]);
    }) 

    return form;
}

